<template>
  <div class="">
  <NavBar  v-bind:displayLogo="true" v-bind:displayUser="false"></NavBar>
    <div class="jumbotron container" v-if="convocatoria.length">
      <h2 class="lead">{{ convocatoria[0].data.titulo }}</h2>
      <hr class="my-4" />
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <p class="card-text min-card-home"></p>
              <router-link class="btn" :to="{ name: 'login' }">Inicio de sesión</router-link>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <div class="card-body">
              <p class="card-text min-card-home"></p>
              <router-link class="btn" :to="{ name: 'register' }">Regístrese</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import NavBar from '@component-basic/NavBar.vue'
export default {
  components: {
    NavBar
  },
  data() {
    return {
      url: process.env.VUE_APP_ENDPOINT_SERVER_FORMIO
    };
  },
  computed: {
    finishDate() {
      const toDate = this.convocatoria[0]?.data.hasta
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      const date = new Date(toDate)
      return toDate ? date.toLocaleDateString('es-CO', options) : ''
    },
    title () {
      
    },
    ...mapState('general',
        ['convocatoria']
      )
  },
  methods: {
    loginRedirect: function() {
      this.$router.push({ name: "login" });
    },
    registerRedirect: function() {
      this.$router.push({ name: "register" });
    }
  }
};
</script>

<style>
.jumbotron{
    background-color: white;
    font-family: 'Titillium Web', sans-serif;
    font: Titillium Web !important;
    width: 50vw;
    text-align: left !important;
  }
  .lead, .card-header{
    font-size: 2em;
    font-weight: 600;
  }
  .home-description-text , .card-text{
    color: grey;
  }
  .card-header{
    background-color: white;
    border: none;
    text-align: left;
    font-size: 1.5em;
  }
  .card{
    border: none;
  }
  hr{
    display: none;
  }
  .card-header{
  display: block !important;
  padding-left: 0;
}
.card-body{
  padding-left: 0;
  padding-top: 0;
}

</style>
